<template>
    <div class="goods-detail-page">
        <openApp :pageName="`entityGoodsDetail?goodsId=${goodsId}&backName=1&goodsKinds=${goodsKinds}&recommendUserUcode=${recommendUserUcode}`" />
        <!-- <div class="top-nav" v-if="isScrollToBo">
            <div :style="{height:statusBarHeight+'px'}" v-if="!isWechat"></div>
            <van-nav-bar
                title="商品详情"
                left-arrow
                @click-left="back"
            />
        </div> -->
        <template v-if="detailObj.baseInfo">
            <div class="block-item goods-info">
            <van-icon name="arrow-left" @click="back" :style="{top:statusBarHeight>0?(statusBarHeight+'px'):'1rem'}"/>
            <!-- 商品图/视频 -->
            <van-swipe class="goods-img-box" @change="onChangeSwipe" v-if="detailObj.videoList||detailObj.picUrlList" :style="{height:clientWidth+'px'}">
                <template v-if="detailObj.videoList">
                    <van-swipe-item v-for="(video,index) in detailObj.videoList" :key="'video-'+index">
                        <!-- 视频 -->
                        <div class="video-box">
                        <!-- <video-player
                                class="video-player vjs-custom-skin"
                                ref="videoPlayerinfo"
                                :playsinline="true"
                                :options="playerOptions">
                            </video-player> -->
                            <VideoPlayerVue
                            ref="videoPlayerRef"
                            :coverUrl="coverUrl"
                            />
                        </div>
                    </van-swipe-item>
                </template>
                <van-swipe-item v-for="(pic,index) in detailObj.picUrlList" :key="'pic-'+index">
                    <!-- 图片 -->
                    <div class="image-box">
                        <van-image
                            fit="contain"
                            :src="pic?pic:''"
                        />
                    </div>
                </van-swipe-item>
                <template #indicator>
                    <div class="custom-indicator">{{ swipeCurrent + 1 }}/{{(detailObj.picUrlList?detailObj.picUrlList.length:0)+(detailObj.videoList?detailObj.videoList.length:0)}}</div>
                </template>
            </van-swipe>
            <div class="info-box">
                <p class="goods-title van-multi-ellipsis--l3">{{detailObj.baseInfo.name}}</p>
                <div class="h2-title">{{detailObj.baseInfo.goodsSellingPoint}}</div>
                <div class="tag-list">
                    <div v-for="tag in detailObj.labels" :key="tag" class="tag-item">{{tag}}</div>
                </div>
                <div class="price-box" v-if="detailObj.baseInfo.priceType==0">¥ {{detailObj.baseInfo.salePrice}}</div>
                <div class="price-box" v-else>免费</div>
                <div class="express-box">
                    <p class="express-item">
                        <span class="name">运费：</span>
                        <span class="info">{{detailObj.baseInfo.postCost&&detailObj.baseInfo.postCost!=0?'¥'+detailObj.baseInfo.postCost:'包邮'}}</span>
                    </p>
                    <p class="express-item">
                        <span class="name">配送：</span>
                        <span class="info">快递配送</span>
                    </p>
                </div>
            </div>
        </div>
        <!-- 机构信息 -->
        <div class="block-item organization-info" v-if="branchInfo&&is_show_swGoodsInfo_instInfo">
            <div class="title">机构信息</div>
            <div class="organization-detail-box">
                <div class="organization-logo">
                    <img :src="branchInfo.logoImg?branchInfo.logoImg:'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/c-h5-fe/study/morenLogo.png'"/>
                </div>
                <div class="organization-detail">
                    <div class="organization-title an-ellipsis">
                        {{branchInfo.branchName}}
                    </div>
                    <div class="organization-address">
                        <div class="address-text"><span>{{branchInfo.provinceName + branchInfo.cityName + branchInfo.countyName + branchInfo.address}}</span></div>
                    </div>
                </div>
                <div class="organization-btn" @click="toBranch(branchInfo.branchId)">进店逛逛</div>
            </div>
        </div>
        <!-- 详情 -->
        <div class="block-item detail-info">
            <van-tabs v-model="tabActive">
                <van-tab title="详情">
                    <div class="detail-text-item" 
                        v-for="item in detailObj.descriptionList"
                        :key="item.id"
                    >
                        <!-- <div class="item-title" v-if="index.length != 0">45435435</div>
                        <div class="item">
                            <div class="desc">{{item}}52352524543534534534543543543543</div>
                            <div class="img">
                                <van-image
                                    fit="contain"
                                    :src="item.image || 'https://img01.yzcdn.cn/vant/cat.jpeg'"
                                />
                            </div>
                        </div> -->
                        
                         <div v-html="item.description" class="introCode"></div>
                    </div>
                </van-tab>
            </van-tabs>

        </div>
        <!-- 其它课程 -->
        <div class="block-item other-list" v-if="otherList.length&&is_show_swGoodsInfo_GoodsRec">
            <div class="title">本机构商品推荐</div>
            <goodsList :list="otherList" :type="1"/>
        </div>
        
        <div class="block-item other-list" v-if="coruseList.length&&is_show_swGoodsInfo_courseRec">
            <div class="title">本机构课程推荐</div>
            <coruseList :list="coruseList" :type="0"/>
        </div>
        <div class="bottom-fixed">
            <div class="buy-bar-box">
                <div class="buy-handle-box" v-if="is_show_swGoodsInfo_shareicon">
                    <div class="buy-handle-item" @click="shareOut(1)">
                    <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/goods/icon-share.png"/>
                        <div>分享</div>
                    </div>
                    <!-- <div class="buy-handle-item" v-if="isShare&&isApp" @click="shareOut(2)">
                        <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/goods/ic-gift.png"/>
                        <div>分享有礼</div>
                    </div> -->
                    <!-- <div class="buy-handle-item">
                        <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/goods/icon-qus.png"/>
                        <div>在线咨询</div>
                    </div> -->
                </div>
                <div class="detail-btn btn-buy" @click="handleBuy">立即购买</div>
            </div>
            <div :style="{height:bottomSafeHeight+'px'}"></div>
        </div>
        <van-sku
            :class="sku.none_sku?'sku-pannel':''"
            v-model="showSku"
            :sku="sku"
            :goods="detailObj.baseInfo"
            :goods-id="detailObj.baseInfo.id"
            :initial-sku="initialSku"
            :show-add-cart-btn="false"
            :reset-selected-sku-on-hide="true"
            buy-text="确定"
            :hide-stock="false"
            @sku-selected="changeSku"
            @buy-clicked="onBuyClicked"
            :safe-area-inset-bottom="true"
        >
            <template #sku-header>
                <div class="goods-header-box">
                    <div class="goods-header-image">
                        <div class="tag-type">实物商品</div>
                        <!-- <img :src="detailObj.picUrlList?detailObj.picUrlList[0]:''"/> -->
                        <van-image
                            fit="contain"
                            :src="detailObj.picUrlList?detailObj.picUrlList[0]:''"
                        />
                    </div>
                    <div class="goods-header-info">
                        <div class="goods-title van-multi-ellipsis--l2">{{detailObj.baseInfo?detailObj.baseInfo.name:''}}</div>
                        <div class="goods-price-num-box">
                            <!-- <div class="goods-price" v-if="detailObj.baseInfo.priceType==0">￥{{Math.floor(selectGood?selectGood.price*skuNum*100:detailObj.baseInfo.salePrice*100)/100}}</div> -->
                            <div class="goods-price" v-if="detailObj.baseInfo.priceType==0">￥{{selectGood?selectGood.price:detailObj.baseInfo.salePrice}}</div>
                            <div class="goods-price" v-else>免费</div>
                            <div class="goods-pay-num">
                                <van-stepper v-model="skuNum" min="1" :max="selectStocks" integer />
                            </div>
                        </div>
                    </div>
                </div>
                
            </template>
            <template #sku-stepper>
                <div>
                    <div class="tips" v-if="selectRemark">
                        备注：{{selectRemark}}
                    </div>
                </div>
            </template>
            <template #sku-actions="props">
            <div class="van-sku-actions">
                <van-button
                    square
                    size="large"
                    type="danger"
                    @click="props.skuEventBus.$emit('sku:buy')"
                >
                    立即购买
                </van-button>
                <div :style="{height:bottomSafeHeight+'px',width:'100%'}"></div>
            </div>
        </template>
        </van-sku>
        
        </template>
        
        <div v-else class="loadingBox">
            <div v-if="!isError">
                <van-loading type="spinner" color="#1989fa" />
                <div>加载中...</div>
            </div>
            <div v-else class="error-box">
                <div class="error-img"><van-icon name="warning" /></div>
                <div class="error-message">{{errorMessage}}</div>
                <div class="error-back" @click="back">返回</div>
            </div>
        </div>
        <div class="share-tip" v-show="isShareShow">
            <p>点击右上角···<br>转发给指定好友或分享到朋友圈</p>
        </div>
    </div>
</template>

<script>
import goodsList from './components/goodsList.vue';
import coruseList from './components/coruseList.vue';
import VideoPlayerVue from "./components/VideoPlayer.vue";
import openApp  from './components/openApp.vue'
import share from '../../../utils/share';
import Applogo from '../asset/images/app_logo.png'
import {sensorsMixin} from './mixins/sensors'
export default {
    components: {
        goodsList,
        coruseList,
        VideoPlayerVue,
        openApp,
    },
    mixins: [sensorsMixin],
    beforeRouteLeave(to,from, next) {
        this.leavePage();
        next();
    },
    data() {
        return {
            isApp:false,
            goodsId:parseInt(this.$route.query.goodsId),//商品ID
            goodsKinds: this.$route.query.goodsKinds,
            selectStocks:10,
            selectRemark:'',
            statusBarHeight:0,
            bottomSafeHeight:0,
            isWechat: this.$publicFn.getUserAgent() === 'wechat',
            coverUrl:'',
            isDraw: 0,
            goodsType: null, 
            swipeCurrent: 0,
            isScrollToBo:false,
            isShare:false,
            // playerOptions: {
            //     //播放速度
            //     // playbackRates: [0.5, 1.0, 1.5, 2.0], 
            //     //如果true,浏览器准备好时开始回放。
            //     autoplay: true,
            //     // 默认情况下将会消除任何音频。
            //     muted: true, 
            //     // 导致视频一结束就重新开始。
            //     loop: false, 
            //     // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
            //     preload: 'auto', 
            //     language: 'zh-CN',
            //     // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
            //     aspectRatio: '16:9',
            //     // 当true时，Video.js player将拥有流体大小。换句话说,它将按比例缩放以适应其容器。
            //     fluid: true,
            //     sources: [{
            //         //类型
            //         type: "video/mp4",
            //         //url地址
            //         src: ''
            //     }],
            //     //你的封面地址
            //     poster: '', 
            //     //允许覆盖Video.js无法播放媒体源时显示的默认信息。
            //     notSupportedMessage: '此视频暂无法播放，请稍后再试',
            //     controlBar: {
            //         timeDivider: true,
            //         durationDisplay: true,
            //         remainingTimeDisplay: false,
            //         //全屏按钮
            //         fullscreenToggle: false  
            //     },
            //     // skinLayout: [{ name: 'bigPlayButton', align: 'cc' }],
            // },
            selectGood:{},
            detailObj:{
              
            },
            entityParams:{
                name: '',
                sortType: 0,
                excludeIds:[],
                pageNum:1,
                pageSize:2,
                hasBranchInfo:false,
                branchId:''
            },
            mallParams:{
                name: '',
                sort: 1,
                vocationCodes:"",
                exceptIdList:[],
                branchId:''
            },
            pageParams:{
                pageNum:1,
                pageSize:2,
            },
            initialSku:{},
            // detailData: {
                // 商品图
                // goods: [
                //     {
                //         value: '视频',
                //         type: 1,
                //         id: 1232,
                //     },
                //     {
                //         value: '图片',
                //         type: 2,
                //         id: 45435,
                //     }
                // ],
                // goodsId: this.$route.query.goodsId,
            // },
            currentlyPlay: {

            },
            
            tabActive: 1,

            //目录
            catalogList:[//目录列表
            ],
            isFirst:true,//是否一级
            isOverType:'ok',

            //推荐商品列表
            otherList: [],
            //推荐课程列表
            coruseList:[],
            showSku: false,
            skuNum: 1,
            sku: {
                // 所有sku规格类目与其值的从属关系，比如商品有颜色和尺码两大类规格，颜色下面又有红色和蓝色两个规格值。
                // 可以理解为一个商品可以有多个规格类目，一个规格类目下可以有多个规格值。
                tree: [],
                list: [],
                price: '', // 默认价格（单位元）
                stock_num: 0, // 商品总库存
                collection_id: 0, // 无规格商品 skuId 取 collection_id，否则取所选 sku 组合对应的 id
                none_sku: false, // 是否无规格商品
            },
            fromName:'',
            errorMessage:'',
            isError:false,
            branchInfo:{},
            clientWidth:375,
            isWd:this.$route.query.isWd?true:false,
            recommendUserUcode:"",
            isShareShow:false,
            is_show_swGoodsInfo_instInfo:false,
            is_show_swGoodsInfo_courseRec:false,
            is_show_swGoodsInfo_GoodsRec:false,
            is_show_swGoodsInfo_shareicon:false
        }
    },
    created() {
        // localStorage.setItem('shurl',window.location.href.split('#')[0]);
        if(localStorage.getItem('statusBarHeight')){
            this.statusBarHeight = localStorage.getItem('statusBarHeight');
            this.bottomSafeHeight = localStorage.getItem('bottomSafeHeight');
        }else{
            this.statusBarHeight = this.$publicFn.getQueryVariable('statusBarHeight');
            this.bottomSafeHeight = this.$publicFn.getQueryVariable('bottomSafeHeight');
        }
        if(this.$route.query.recommendUserUcode){
            sessionStorage.setItem('recommendUserUcode',this.$route.query.recommendUserUcode)
        }
        this.recommendUserUcode =sessionStorage.getItem('recommendUserUcode');
        this.configMenuInfor();
        this.getDetail();
        // this.findMallGoodsList();
        if (window.history && window.history.pushState) {
            // 往历史记录里面添加一条新的当前页面的url
            history.pushState(null, null, document.URL);
            // 给 popstate 绑定一个方法 监听页面刷新
            window.addEventListener("popstate", this.back, false); //false阻止默认事件
        }
        this.clientWidth = document.documentElement.clientWidth || document.body.clientWidth;
        console.log('clientWidth-----------',this.clientWidth)
    },
    mounted(){
        window.addEventListener('scroll',this.handleScroll)
        this.$WDJSBridge.useGetAppVersion().then(res=>{
            console.log('获取版本号成功', res)
            this.isApp = res?true:false;
        }).catch(err=>{
            console.log('获取版本号失败', err)
        })
        const that = this;
        window.addEventListener( 'beforeunload', e => {
            that.leavePage();
        });
    },
    beforeDestroy() {
      document.title = localStorage.getItem('pageTitle');
    },
    destroyed(){
        window.removeEventListener("popstate", this.back, false); //false阻止默认事件
        // localStorage.setItem('detailAgentId', this.$route.query.agentId || '')
    },
    // beforeRouteUpdate(to, from, next){
    //     this.goodsId = to.query.goodsId;
    //     window.removeEventListener("popstate", this.back, false);
    //     this.getDetail();
    //     next();
    // },
    methods: {
        shareH5(){
          if(this.isWechat&&this.is_show_swGoodsInfo_shareicon){
            this.isShareShow = true;
            setTimeout(() => {
              this.isShareShow = false
            },5000)
          }else{
            this.$toast('请使用浏览器自带分享进行分享')
          }
        },
        //获取机构基本信息
        getBranchInformationByBid(){
            const params = {
                branchId: this.detailObj.baseInfo.branchId,
            };
            this.$api.entityGoodsDetail.getBranchInformationByBid(params).then((res) => {
                if (res.success) {
                    this.branchInfo = res.data;
                }
            });
        },
        shareOut(type){
            this.onTrack('commodity_share',{
                percentage_rate:0,
                is_promoter:false,
            })
            if(this.isApp){
                let recommendUserUcode = localStorage.getItem('token')?localStorage.getItem('userInfo')&&JSON.parse(localStorage.getItem('userInfo')).userUcode:'';
                this.$WDJSBridge.useShare(JSON.stringify({
                    path:`/entityGoodsDetail?goodsId=${this.detailObj.baseInfo.id}&goodsKinds=3&isWd=1&recommendUserUcode=${recommendUserUcode}`,
                    title:this.detailObj.baseInfo.name,
                    icon:this.detailObj.picUrlList?this.detailObj.picUrlList[0]:'',
                    desc:this.detailObj.baseInfo.goodsSellingPoint?this.detailObj.baseInfo.goodsSellingPoint:'',
                    type:type,
                    award:'',
                })).then(res=>{
                    console.log('分享成功', res)
                }).catch(err=>{
                    console.log('分享失败', err)
                })
            }else{
                this.shareH5();
            }
        },
        async toBranch(id){
            let url = await this.$publicFn.getSaasBranchDomain(id)
            // window.open(url+'/stationPage')
            if(this.isApp){
                this.$WDJSBridge.useNewPage(JSON.stringify({
                    url:url+'/stationPage',
                    pageName:'stationPage'
                })).then(res=>{
                    console.log('跳转成功', res)
                }).catch(err=>{
                    console.log('页面跳转错误', err)
                })
            }else{
                // window.open(url+'/stationPage')
                window.location.href = url+'/stationPage';
            }
        },
        getLogParams() {
            const {id:aff_institution_id = '', name: aff_institution_name = ''} = this.detailObj.branch || {};
            const {goodsId: commodity_id, goodsKinds} = this.$route.query;
            const {name, salePrice, basePrice} = this.detailObj.baseInfo || {}
            const [
                    commodity_firstcate = '', 
                    commodity_secondcate = '', 
                    commodity_thirdcate = ''
            ] = this.detailObj.baseInfo ? this.detailObj.baseInfo.categoryPath || [] : [];

            return {
                commodity_id,
                goodsKinds,
                aff_institution_id: String(aff_institution_id),
                aff_institution_name,
                commodity_firstcate,
                commodity_secondcate,
                commodity_thirdcate,
                commodity_name: name || '',
                original_price: basePrice || '',
                current_price: salePrice || '',
            }
        },
        //获取是否显示分享按钮、机构信息、本机构推荐课程
        configMenuInfor(){
            const frontendConfig = this.$store.state.dynamic.frontendConfig || [];
            frontendConfig.length && frontendConfig.filter( (item) => {
                switch(item.key) {
                    case  "is_show_downloadApp": // 分享配置
                        this.showConfig = item.value == 'true'
                        break;
                    case  "is_show_swGoodsInfo_instInfo": // 实物商品详情页-显示机构信息
                        this.is_show_swGoodsInfo_instInfo = item.value == 'true'
                        break;
                    case  "is_show_swGoodsInfo_courseRec": // 实物商品详情页-显示本机构推荐商品
                        this.is_show_swGoodsInfo_courseRec = item.value == 'true'
                        break;
                    case  "is_show_swGoodsInfo_GoodsRec": // 实物商品详情页-显示本机构推荐商品
                        this.is_show_swGoodsInfo_GoodsRec = item.value == 'true'
                        break;
                    case  "is_show_swGoodsInfo_shareicon": // 培训商品详情页-显示分享按钮
                        this.is_show_swGoodsInfo_shareicon = item.value == 'true'
                        break;
                    default:
                        break;
                }
            });
        },
        //推荐商品
        getEntityGoodslist(){
            this.$api.entityGoodsDetail.getEntityGoodslist(this.entityParams).then((res)=>{
                console.log(res)
                if(res.code==0&&res.data.list){
                    this.otherList=res.data.list;
                }
                console.log('otherList',this.otherList)
            })
        },
        //推荐课程
        findMallGoodsList(){
            this.$api.entityGoodsDetail.findMallGoodsList(this.pageParams,this.mallParams).then((res)=>{
                console.log(res)
                if(res.code==0&&res.data.list){
                    this.coruseList=res.data.list;
                }
                console.log('coruseList',this.coruseList)
            })
        },
        handleScroll(){
            // console.log(window.scrollY)
            if(window.scrollY>=30){
                this.isScrollToBo = true;
            }else{
                this.isScrollToBo = false;
            }
        },
        back(){
            console.log('isApp',this.isApp)
            if(this.isApp){
                if(this.$route.query.visit_referrer == 'home' || this.$route.query.visit_referrer == 'study'){
                    this.$WDJSBridge.useBack().then(res=>{
                        console.log('跳转成功', res)
                        this.leavePage();
                    }).catch(err=>{
                        console.log('页面跳转错误', err)
                    })
                }else{
                    this.$router.go(-1)
                }
            } else {
                if(this.isWd){
                    this.$router.push('/study?active=2');
                }else{
                    this.$router.go(-1)
                }
            }
        },
        //获取视频信息播放
    //   getVideo(){
    //     this.$api.entityGoodsDetail
    //     .detail({
    //       shortVideoId: this.detailObj.videoList[0],
    //     })
    //     .then((res) => {
    //       if (res.code === 0) {
    //         const { title, coverUrl, resourceId } = res.data;

    //         this.coverUrl = coverUrl;

    //         this.getVideoPlayAuth(resourceId);

    //         return;
    //       }
    //     })
    //   },
      getVideoPlayAuth() {
        return this.$api.entityGoodsDetail
          .videoPlayAuth({ shortVideoId: this.detailObj.videoList[0],hashCover:true })
          .then((res) => {
            const playParams = {
              format: "m3u8",
              mediaType: "video",
            };
            this.$nextTick(() => {
                if(res.data?.sourceSing && (res.data?.sourceSing=='222' || res.data.sourceSing=='333')){
                  // 三方，222 格莱森的，333交通的
                  this.$refs.videoPlayerRef[0].initPlayer(res.data.playUrl,true)
              }else{
                  this.$refs.videoPlayerRef[0].initPlayer(res.data.playAuth,false, playParams)
              }
            })
            return res;
          })
          .catch((err) => err);
      },
        getDetail() {
            this.$api.entityGoodsDetail.findGoodsDetailById({
                goodsId:this.goodsId,
                goodsKinds:this.$route.query.goodsKinds,
                hasBaseInfo: true,
                hasBranchInfo: false,
                hasCarousel: true,
                hasDesc: true,
                hasLabel: true,
                hasSku: true
            }).then((res)=>{
                console.log(res)
                if(res.code==0){
                    this.detailObj = res.data;
                    this.getBranchInformationByBid();
                    document.title = this.detailObj.baseInfo.name
                    if(this.isWechat&&this.is_show_swGoodsInfo_shareicon) {
                        let recommendUserUcode = localStorage.getItem('token')?localStorage.getItem('userInfo')&&JSON.parse(localStorage.getItem('userInfo')).userUcode:'';
                        share.getShare(this,{
                            imgUrl: 'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/c-mini/app_logo.png',
                            title: this.detailObj.baseInfo.name,
                            desc: '点击查看详情',
                            link:`${window.location.protocol}//${window.location.host}/entityGoodsDetail?goodsId=${this.detailObj.baseInfo.id}&goodsKinds=3&isWd=1&recommendUserUcode=${recommendUserUcode}`
                        })
                    }
                    if(this.detailObj.videoList&&this.detailObj.videoList.length>0){
                        this.getVideoPlayAuth()
                    }
                    this.entityParams.excludeIds = [res.data.baseInfo.id]
                    this.selectGood.price = this.detailObj.baseInfo.salePrice;
                    // this.initPlayer();
                    this.entityParams.branchId = this.detailObj.baseInfo.branchId;
                    this.mallParams.branchId = this.detailObj.baseInfo.branchId;
                    this.findMallGoodsList();
                    this.getEntityGoodslist();
                    this.sku.price = this.detailObj.baseInfo.salePrice;
                    this.sku.stock_num = this.detailObj.baseInfo.stocks;
                    if(this.detailObj.goodsSkuList&&this.detailObj.goodsSkuList.length>0){
                        this.detailObj.goodsSkuList.forEach((item1,index1)=>{
                            var obj = {
                                id: item1.id, // skuId
                                // s1: '1', // 规格类目 k_s 为 s1 的对应规格值 id
                                // s2: '1', // 规格类目 k_s 为 s2 的对应规格值 id
                                price: item1.salePrice, // 价格（单位分）
                                stock_num: item1.stocks, // 当前 sku 组合对应的库存
                                remark:item1.remark
                            }
                            if(item1.specsGroup.length&&item1.specsGroup.length>0){
                                item1.specsGroup.forEach((item2,index2)=>{
                                    var objson = {
                                        k: '', // skuKeyName：规格类目名称
                                        k_s: '', // skuKeyStr：sku 组合列表（下方 list）中当前类目对应的 key 值，value 值会是从属于当前类目的一个规格值 id
                                        v: [],
                                        largeImageMode: false, //  是否展示大图模式
                                    }
                                    if(this.sku.tree.length<item1.specsGroup.length){
                                        objson.k = item2.key;
                                        objson.k_s = 's'+index2;
                                        this.sku.tree.push(objson);
                                    }
                                    if(!this.sku.tree[index2].v.some(item=>item.name==item2.value)){
                                        this.sku.tree[index2].v.push({
                                            id:item2.value,
                                            name:item2.value
                                        })
                                    }
                                    obj['s'+index2] = item2.value;
                                })
                            }
                            this.sku.list.push(obj)
                        })
                        console.log(this.sku.list)
                        console.log(this.sku.tree)
                        this.initialSku = this.sku.list[0];
                        this.selectStocks = this.sku.list[0].stock_num;
                        this.selectRemark = this.sku.list[0].remark;
                    }else{
                        this.sku.collection_id = this.detailObj.baseInfo.id;
                        this.sku.none_sku = true;
                        this.selectStocks = this.detailObj.baseInfo.stocks;
                    }

                    // 埋点
                    this.onTrack('commodity_details_show',{
                        visit_referrer: this.fromName,
                    })
                }else{
                    this.isError = true;
                    this.errorMessage = res.message;
                }
            }).catch(err=>{
                console.log('加载异常', err)
                this.isError = true;
                this.errorMessage = '加载异常';
            })
        },
        // initPlayer() {
        //     this.playerOptions.sources[0].src = this.detailObj.videoList[0]?'https://vodplay.wdyedu.com/500ae788145244fa99e536da11bcb744/0d676d776976441bb2908393f0ceac1d-be5387ab81d28dff2e95902a6fa68e93-sd.mp4':'https://vodplay.wdyedu.com/500ae788145244fa99e536da11bcb744/0d676d776976441bb2908393f0ceac1d-be5387ab81d28dff2e95902a6fa68e93-sd.mp4'
        // },
        onChangeSwipe(index) {
            this.swipeCurrent = index;
            // const {goods} = this.detailData
            //当前类型
            // const currentItemType = goods[index].type;
            // console.log('player',this.$refs.videoPlayerinfo[0]);
            // this.$refs.videoPlayerinfo[0].player.pause(false);
        },
        onBuyClicked(item) {
            console.log(item);
            if(localStorage.getItem('token')){
                this.onTrack('buy_commodity_click',{
                    buy_type: '付费',
                })
                if(!this.sku.none_sku){
                    this.selectGood = item.selectedSkuComb;
                }
                var dataObj;
                if(this.sku.none_sku){
                    dataObj = {
                        goodsId:item.goodsId,
                        num:this.skuNum,
                        shareUserInfo:sessionStorage.getItem('recommendUserUcode')?sessionStorage.getItem('recommendUserUcode'):''
                    }
                }else{
                    dataObj = {
                        goodsId:item.goodsId,
                        num:this.skuNum,
                        skuId:this.selectGood.id,
                        shareUserInfo:sessionStorage.getItem('recommendUserUcode')?sessionStorage.getItem('recommendUserUcode'):''
                    }
                }
                this.$api.entityGoodsDetail.orderEntityGoods(dataObj).then((res)=>{
                    if(res.code==0){
                        this.$router.push({
                            path:`/order/index/${res.data}`
                        })
                    }
                })
            }else{
                if(this.isApp){
                    this.onTrack('login_page_show',{
                        show_reason: '购买',
                    })
                    this.$WDJSBridge.jumpNAPage(JSON.stringify({pageName: 'login'})).then(res=>{
                        console.log('跳转成功', res)
                    }).catch(err=>{
                        console.log('页面跳转错误', err)
                    });
                }else{
                    this.$router.push({
                        path: "/login",
                        query: { 
                            name: "entityGoodsDetail",
                            ...this.$route.query,
                            purchase:1
                        }
                    });
                }
            }
        },
        handleBuy() {
            // if(this.isApp){
                this.showSku = true;
            // }else{
            //     this.$toast('请点击右上角下载APP购买')
            // }
        },
        changeSku(obj){
            console.log(obj)
            this.selectGood = obj.selectedSkuComb;
            this.selectStocks = obj.selectedSkuComb.stock_num;
            this.selectRemark = obj.selectedSkuComb.remark;
        }
    },
}
</script>

<style lang="less">
    body,html {
        background: #F8FAFC;
    }
</style>
<style lang="less" scoped>
.goods-detail-page {
    padding-bottom: 144px;
    position: relative;
    .share-tip{
        width: 405px;
        height: 122px;
        background: rgba(0, 0, 0, 0.6);
        border-radius: 16px;
        position: fixed;
        top: 32px;
        right: 32px;
        box-sizing: border-box;
        padding: 16px;
        z-index:9999999100;
        &::after{
          position: absolute;
          content: '';
          border-top: 20px transparent dashed;
          border-left: 20px transparent solid;
          border-bottom: 20px rgba(0, 0, 0, .6) dashed;
          border-right:20px transparent dashed;
          right: 24px;
          top: -39px;
        }
        p{
          font-size: 26px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 40px;
        }
      }
    .tips{
        padding-left:32px;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 33px;
        margin-top:16px;
    }
    .loadingBox{
        text-align: center;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
    }
    .loadingBox div{
        font-size: 0.7rem;
        color: rgb(25, 137, 250);
        margin-top: 0.6rem;
    }
    .error-box{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 0!important;
        .error-img{
            margin: 0!important;
            i{
                font-size: 100px;
                color: #ee0a24;
            }
        }
        .error-message{
            text-align: center;
            font-size: 30px;
            color: #333;
        }
        .error-back{
            width: 300px;
            text-align: center;
            height: 80px;
            line-height: 80px;
            color:#fff;
            font-size: 30px;
            border-radius: 40px;
            background-color: #1F94FF;
        }
    }
    .bottom-fixed{
        position: fixed;
        bottom: 0;
        width: 100%;
        border-top: 1px solid #EAEAEA;
        background-color: #fff;
        z-index: 1;
    }
    .sku-pannel{
        min-height:8.8267rem;
        /deep/.van-sku-body{
            // display:none;
            min-height:max-content;
        }
        /deep/.van-sku-messages{
            padding:0;
        }
    }
    .introCode{
        word-break:break-all;
        width:100%;
        position: relative;
        overflow: hidden;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 40px;
        ::v-deep {
            img {
                width: 100%;
                height: auto;
                vertical-align: bottom;  
            }
            p{
                width:100%;
            }
            div{
                width:100%
            }
        }
    }
    .top-nav{
        position: fixed;
        width:100%;
        top:0;
        z-index:11;
        background:#fff;
        /deep/.van-nav-bar__title{
            font-size: 0.96rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 1.333rem;
        }
        /deep/.van-icon-arrow-left{
            font-size: 1.493rem;
        }
        /deep/.van-nav-bar__left{
            padding-left: 0.64rem;
        }
        /deep/.van-nav-bar__content{
            height: 2.507rem;
        }
    }
    ::v-deep {
        .van-hairline--bottom:after{
            border:0;
        }
        .van-sku-row__item{
            font-size: 0.64rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 0.693rem;
            padding:0.4rem 0.427rem;
            background: #F5F6FA;
            min-width:auto;
            border: 0.027rem solid #F5F6FA;
            margin:0 0.213rem 0.533rem 0;
            .van-sku-row__item-name{
                padding:0;
            }
        }
        .van-sku-row__item--disabled{
            color: #c8c9cc;
            background: #f2f3f5;
        }
        .van-sku-row__title{
            font-size: 0.747rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 1.067rem;
        }
        .van-sku-row__item--active{
            background: rgba(31, 148, 255, 0.12);
            border: 0.027rem solid #0089FF;
            color:#0089FF;
        }
        .vjs-custom-skin > .video-js .vjs-progress-control.vjs-control{
            display: none;
        }
        .van-sticky--fixed {
            // padding-left: 32px;
            border-top:0.027rem solid #EAEAEA;
            border-bottom:0.027rem solid #EAEAEA;
            padding: 0 0.853rem;
            background: #fff;
            top:2.43rem;
        }
        .van-tabs__content{
            padding: 0.853rem 0 0.82rem;
            border-top:0.027rem solid #EAEAEA;
        }
        .goods-info{
            position: relative;
            .van-icon-arrow-left{
                position: absolute;
                top: 1rem;
                left: 0.8rem;
                font-size: 0.8rem;
                color: #ffffff;
                z-index: 10;
                padding: 0.3rem;
                background: rgba(0,0,0,0.4);
                border-radius: 50%;
            }
        }
    }
    
    .van-swipe {
        // height: 400px;
        .video-box {
            height: 100%;
            .video-player{
                width:100%;
                height: 100%;
                display: flex;
                align-items: center;
            }
        }
        .image-box{
            height: 100%;
            display: flex;
            align-items:center;
            justify-content: center;
            background:#F8FAFC;
            /deep/.van-image{
                height: 100%;
                width:100%;
            }
        }
    }
    .custom-indicator {
        position: absolute;
        right: 32px;
        bottom: 24px;
        padding: 0 19px;
        font-size: 26px;
        min-width: 88px;
        height: 48px;
        box-sizing: border-box;
        line-height: 48px;
        border-radius: 24px;
        background: rgba(0, 0, 0, 0.6);
        color: #fff;
        text-align: center;
    }
    .block-item {
        margin-bottom: 16px;
        padding: 0 32px 8px;
        background-color: #fff;
        .title {
            padding: 24px 0;
            color: #333;
            font-size: 36px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
        }
    }
    .detail-info {
        ::v-deep {
            .van-tabs__line {
                display: none;
            }
            .van-tabs__wrap{
                height: 3.04rem;
                // border-bottom:0.027rem solid #EAEAEA;
                // margin-bottom:0.853rem;
            }
            .van-tabs__nav--line {
                justify-content: flex-start;
                padding-bottom:0;
                .van-tab {
                    flex: 0 auto;
                    // margin-right: 56px;
                    padding:0;
                    font-size: 0.96rem;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #333333;
                }
            }
        }
    }
    .goods-info {
        padding: 0;
        .goods-img-box {
            // height: 562px;
            margin-bottom: 32px;
            background:#000;
        }
        .info-box {
            padding: 0 32px;
        }
        .goods-title {
            font-size: 36px;
            color: #333;
            line-height: 50px;
            margin-bottom: 12px;
            font-weight: 500;
        }
        .h2-title{
            font-size: 26px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 37px;
            margin:12px 0 8px;
            display: -webkit-box;
            overflow: hidden;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical
        }
        .desc {
            color: #666;
            line-height: 37px;
            font-size: 26px;
        }
        .tag-list {
            margin-bottom: 16px;
            overflow: hidden;
            .tag-item{
                float: left;
                padding:8px 12px;
                font-size: 20px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #1F94FF;
                background: rgba(31, 148, 255, 0.12);
                border-radius: 4px;
                margin:0 8px 8px 0;
                line-height: 20px;
            }
        }
        .price-box {
            color: #FE5746;
            font-size: 44px;
            line-height: 60px;
            font-weight: 600;
            margin-bottom: 24px;
        }
        .name {
            color: #333330;
        }
        .info {
            color: #999;
        }
        .express-box {
            border-top: 1px solid #EAEAEA;
            padding: 24px 0;
            .express-item {
                font-size: 24px;
                height: 33px;
                align-items: center;
                display: flex;
                margin-bottom: 24px;
                &:last-of-type {
                    margin-bottom: 0;
                }
                
            }
        }
        .apply-box {
            border-top: 1px solid #EAEAEA;
            padding: 24px 0;
            display: flex;
            justify-content: space-between;
            font-size: 24px;

        }
    } 
    .organization-info {
        padding-bottom: 32px;
        .organization-detail-box {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            position: relative;
            .organization-btn {
                width: 168px;
                height: 64px;
                border-radius: 44px;
                background-color: #1F94FF;
                text-align: center;
                line-height: 64px;
                color: #fff;
                font-size: 26px;
                position: absolute;
                right: 0;
                bottom:0;
            }
            .organization-logo {
                width: 120px;
                height: 120px;
                border: 1px solid #f0f0f0;
                margin-right: 24px;
                border-radius: 14px;
                overflow: hidden;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            .organization-detail {
                flex: 1;
                height: 120px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                .organization-title{
                    font-size: 30px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #333333;
                    line-height: 34px;
                    display: -webkit-box;
                    overflow: hidden;
                    -webkit-line-clamp: 1;
                    -webkit-box-orient: vertical;
                }
            }
            .rganization-title {
                font-size: 30px;
                height: 42px;
                line-height: 42px;
                color: #333;
                font-weight: 500;
                margin-bottom: 10px;
            }
            .organization-address {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width:330px;
                .address-text {
                    color: #999;
                    font-size: 24px;
                    // display: flex;
                    // align-items: center;
                    display: -webkit-box;
                    overflow: hidden;
                    -webkit-line-clamp: 1;
                    -webkit-box-orient: vertical;
                    // .l {
                    //     margin-right: 12px;
                    //     padding-right: 12px;
                    //     border-right: 2px solid #D8D8D8;
                    //     display: flex;
                    //     align-items: center;
                    //     img{
                    //         height: 24px;
                    //         width: 24px;
                    //         margin-right: 4px;
                    //     }
                    // }
                }
            }
        }
    }
    .detail-info {
        .detail-text-item {
            margin-bottom: 32px;
            .mce-editor-image {
                max-width: 100%;
                max-height: 100%;
            }
            .item-title {
                font-size: 32px;
                color: #333;
                position: relative;
                padding-left: 14px;
                margin-top: 32px;
                &::before {
                    content: '';
                    width: 6px;
                    height: 24px;
                    position: absolute;
                    left: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    background-color: #1F94FF;
                    border-radius: 3px;
                }
            }
            .item div {
                margin-top: 16px;
            }
            &:last-of-type {
                margin-bottom: 0;
            }
            .desc {
                word-break: break-all;
                color: #666;
                font-size: 28px;
                line-height: 40px;
            }
            .img {
                max-width: 100%!important;
                display: block;
                margin: 0 auto;
            }
        }
    }
    .buy-bar-box {
        // height: 104px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 12px 32px;
        // position: fixed;
        // bottom: 0;
        // width: 100%;
        box-sizing: border-box;
        // background-color: #fff;
        // border-top: 1px solid #EAEAEA;
        // z-index: 1;
        .buy-handle-box {
            display: flex;
            justify-content: space-between;
            margin-right: 32px;
            .buy-handle-item {
                text-align: center;
                font-size: 22px;
                color: #333;
                width: 112px;
                // margin-right: 16px;
                img{
                    width:48px;
                    height: 48px;
                }
                // &:last-of-type {
                //     margin-right: 32px;
                // }
            }
            .icon {
                display: inline-block;
                width: 36px;
                height: 36px;
                background-color: #f00;
            }
        }
        .detail-btn {
            flex: 1;
            text-align: center;
            height: 80px;
            line-height: 80px;
            color:#fff;
            font-size: 30px;
            border-radius: 40px;
            &.btn-buy {
                background-color: #FE5746;
            }
            &.btn-ask,&.btn-study {
                background-color: #1F94FF;
            }

        }
    }    
}

::v-deep {
    .van-sku-actions {
      box-shadow: inset 0px 1px 0px 0px #EAEAEA;
      flex-direction: column;
    }
    .van-button {
      border-radius:1.1733rem!important;
      width: 18.29rem;
      height: 2.13rem;
      background: #FE5746;
      border-radius: 1.17rem;
    }
    .van-button__text {
      font-size: 0.8rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 0.85rem;
    }
    &.van-popup {
        padding-top: 2.347rem;
    }
    .van-stepper__input{
        background-color:#EAEAEA;
    }
    .van-stepper__minus, .van-stepper__plus{
        background-color:#fff!important;
        width:20px;
        height: 20px;
    }
    .van-stepper__input{
        width: 36px;
        height: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        margin:0 8px;
    }
    .goods-header-box {
        display: flex;
        flex-shrink: 0;
        margin: 0 16px 40px;
        .goods-header-image {
            flex-shrink: 0;
            width: 240px;
            height: 240px;
            margin-right: 24px;
            overflow: hidden;
            border-radius: 14px;
            background-color: #ccc;
            position: relative;
            .tag-type{
                position:absolute;
                left:0;
                top:0;
                width: 104px;
                height: 36px;
                background: rgba(0, 0, 0, 0.6);
                border-radius: 14px 0px 8px 0px;
                font-size: 20px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 36px;
                text-align:center;
            }
            .van-image{
                width:100%;
                height:100%;
            }
        }
        .goods-header-info {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }
        .goods-title {
            font-size: 30px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333;
            line-height: 42px;
            margin-bottom: 52px;
        }
        .goods-price-num-box {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .goods-price {
                color: #FE5746;
                font-size: 32px;
            }
        }
    }
}
</style>